// extracted by mini-css-extract-plugin
export default {"page":"Meals_page__ApqUp","container":"Meals_container__qs+I+","header":"Meals_header__qelld","bar":"Meals_bar__zad63","table":"Meals_table__87dmw"};